import React from 'react'

import './Footer.scss'

export interface ModalFooterProps {
  position?: 'left' | 'center' | 'right'
  children: React.ReactNode
  showDivider?: boolean
  'data-testid'?: string
}

const ModalFooter = React.memo(
  ({
    position = 'center',
    children,
    showDivider = false,
    'data-testid': dataTestId = 'modal-footer',
  }: ModalFooterProps) => {
    return (
      <footer
        data-testid={dataTestId}
        className={[
          'ModalFooter',
          `ModalFooter--${position}`,
          showDivider ? 'ModalFooter--with-divider' : '',
        ].join(' ')}
      >
        {children}
      </footer>
    )
  },
)

ModalFooter.displayName = 'Modal.Footer'

export default ModalFooter
